import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'

const S = {
  label: css`
    display: flex;
    align-items: center;
    color: var(--Colors-Gray-700);
    font-weight: 500;
    ${typo.caption02};
    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      margin-right: 4px;
      border-radius: var(--Radius-Circle);
      background-color: var(--Colors-Sky-400);
    }
  `,
}

export default S
